import service from 'auth/FetchInterceptor'

const AdminServices = {}

AdminServices.getOrganiztions = async function ({ page, page_size, name }) {
  const config = {
    method: 'get',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/valify/organizations/${
          name ? `?name=${name}` : page && page_size ? `?page_size=${page_size}&page=${page}` : ''
        }`
      : `/admin-portal-backend/v1/valify/organizations/${
          name ? `?name=${name}` : page && page_size ? `?page_size=${page_size}&page=${page}` : ''
        }`,
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  }

  return await service(config)
}
AdminServices.getValifyServices = async function () {
  const config = {
    method: 'get',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/valify/services/`
      : '/admin-portal-backend/v1/valify/services/',
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  }

  return await service(config)
}

AdminServices.getDashboardAnalytics = async function (data) {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/valify/admin-analytics/`
      : '/admin-portal-backend/v1/valify/admin-analytics/',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }

  return await service(config)
}

AdminServices.getBundleSessions = async function (data) {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/valify/bundle-sessions/`
      : '/admin-portal-backend/v1/valify/bundle-sessions/',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }

  return await service(config)
}

AdminServices.getUniqueIdentifiers = async function (data) {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/valify/user-reference-ids/`
      : '/admin-portal-backend/v1/valify/user-reference-ids/',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }

  return await service(config)
}
//add api of valify-session details

// AdminServices.getValifySessionDetails = async function (data) {
//   const config = {
//     method: 'post',
//     url: process.env.REACT_APP_DOMAIN_NAME
//       ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/valify/user-reference-ids-details/`
//       : '/admin-portal-backend/v1/valify/user-reference-ids-details/',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     data,
//     withCredentials: true,
//   }

//   return await service(config)
// }


AdminServices.getValifySessionDetails = async function (data) {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/valify/user-reference-id-transactions/`
      : '/admin-portal-backend/v1/valify/user-reference-id-transactions/',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }

  return await service(config)
}
AdminServices.getBundleTransactions = async function (data) {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/valify/bundle-transactions/`
      : '/admin-portal-backend/v1/valify/bundle-transactions/',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }

  return await service(config)
}

AdminServices.getBundleServices = async function (data) {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/valify/bundle-services/`
      : '/admin-portal-backend/v1/valify/bundle-services/',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }

  return await service(config)
}

AdminServices.getSessionDetails = async function (data) {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/valify/bundle-session-details/`
      : '/admin-portal-backend/v1/valify/bundle-session-details/',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }

  return await service(config)
}
AdminServices.getOrganiztionsBundles = async(data) => {
 
  const config = {
    method: 'post',
    url: `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/valify/organization-bundles/?lang=en`,
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }
  return await service(config)
}
AdminServices.getTransactionDetails = async  function (data) {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/valify/bundle-transaction-details/`
      : '/admin-portal-backend/v1/valify/bundle-transaction-details/',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }

  return await service(config)
}

AdminServices.getOriginalImg = async function (data) {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/valify/original-image/`
      : '/admin-portal-backend/v1/valify/original-image/',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }

  return await service(config)
}

AdminServices.getBoxedImg = async function (data) {
  var config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/valify/boxed-image/`
      : '/admin-portal-backend/v1/valify/boxed-image/',
    headers: {
      'Content-Type': 'application/json',
    },
    data: data,
    withCredentials: true,
  }
  return await service(config)
}

AdminServices.exportData = async function (data) {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/valify/export-images/`
      : '/admin-portal-backend/v1/valify/export-images/',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }
  return await service(config)
}

AdminServices.exportTransactions = async function (data) {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/valify/export-transactions/`
      : '/admin-portal-backend/v1/valify/export-transactions/',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }
  return await service(config)
}


AdminServices.createBundle = async function (data) {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/valify/bundles/create/`
      : '/admin-portal-backend/v1/valify/bundles/create/',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }

  return await service(config)
}

AdminServices.createOrganiztion =async  function (data) {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/valify/organizations/create/`
      : '/admin-portal-backend/v1/valify/organizations/create/',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }

  return await service(config)
}

AdminServices.updateOrganiztion = async function (data) {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/valify/organizations/update/`
      : '/admin-portal-backend/v1/valify/organizations/update/',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }

  return await service(config)
}

AdminServices.getOrganiztionDetails = async function (data) {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/valify/organizations/details/`
      : '/admin-portal-backend/v1/valify/organizations/details/',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }

  return await service(config)
}

AdminServices.getBundleDetails = async function (data) {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/valify/bundles/details/`
      : '/admin-portal-backend/v1/valify/bundles/details/',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }

  return await service(config)
}

AdminServices.getBundleAnalytics = async function (data) {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/valify/bundle-analytics/`
      : '/admin-portal-backend/v1/valify/bundle-analytics/',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }

  return await service(config)
}

AdminServices.getMilvusCollections = async function (data) {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
    ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/valify/get-collections/`
    : '/admin-portal-backend/v1/valify/get-collections/',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }

  return await service(config)
}

AdminServices.biometricsFlow = async function (data) {
    const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
    ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/valify/biometrics-guard/`
    : '/admin-portal-backend/v1/valify/biometrics-guard/',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }

  return await service(config)
  
}
AdminServices.biomatricsFlowOneToMany = async function (data) {
    const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
    ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/valify/search-similar/`
    : '/admin-portal-backend/v1/valify/search-similar/',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }

  return await service(config)

}

// FRA Step Completion Analysis — ePassport onboarding funnel for one bundle
// over a date range.
//
// PLACEHOLDER PATH: adjust the URL here and nothing else in the FRA view needs
// to change.
//
// Payload:  { bundle_id, start_time, end_time }
// Response: { filters, metric_descriptions, totals, steps[] }
AdminServices.getFraStepCompletion = async function (data) {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/valify/bundle-epassport-funnel/`
      : '/admin-portal-backend/v1/valify/bundle-epassport-funnel/',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }

  return await service(config)
}

export default AdminServices
